export const sceneAurora = `
    vec3 sceneAurora(vec3 rd, float time) {
        vec2 ang = vec2(atan(rd.z, rd.x), acos(rd.y));
        float lat = 1.0 - ang.y / PI;
        float baseScroll = time * 0.25;
        vec3 col = vec3(0.0);

        for (float i = 0.0; i < 3.0; i += 1.0) {
            float offset = i * 1.37;
            float wave = sin(ang.x * 3.0 + baseScroll * (0.7 + i * 0.2) + offset);
            float bandPos = 0.25 + 0.25 * i + wave * 0.12;

            vec2 p = vec2(ang.x * 2.0 + offset * 0.5, lat * 3.0 + baseScroll * (0.4 + i * 0.1));
            float ripples = noise(p * 3.5 + time * 0.15 + i * 3.0);
            float ribbon = smoothstep(0.18, 0.02, abs(lat - bandPos - ripples * 0.1));

            float shimmer = noise(vec2(lat * 8.0 + time * 0.6 + i * 2.0, ang.x * 5.0));
            vec3 bandColor = palette(lat * 0.6 + i * 0.08 + time * 0.02);

            col += bandColor * ribbon * (0.4 + shimmer * 0.9);
        }

        col += vec3(smoothstep(0.9, 1.0, lat) * 0.2);
        return col * 1.15;
    }
`;
